import { ChildAgesProps, ChildAges } from './ChildAges';
export { ChildAges as default };
export type { ChildAgesProps };
export { useChildAges } from './useChildAges';
